module.exports = __webpack_public_path__ + "img/ind-zcjd.00299fe7.png";